import React from "react";
import { FaCat, FaGlobe, FaMusic, FaKeyboard, FaBookOpen, FaCode, FaRocket } from "react-icons/fa";
import { SiN8N } from "react-icons/si";

const funFacts = [
  {
    icon: <FaCode className="text-2xl text-mint-500 dark:text-riptide-400" />,
    title: "Passionate Problem-Solver",
    description:
      "I love a good challenge and am always eager to find creative and efficient solutions to complex problems.",
  },
  {
    icon: <FaBookOpen className="text-2xl text-mint-500 dark:text-riptide-400" />,
    title: "Dedicated Learner",
    description:
      "I am passionate about continuous learning, constantly exploring new technologies and best practices to stay ahead.",
  },
  {
    icon: <FaKeyboard className="text-2xl text-mint-500 dark:text-riptide-400" />,
    title: "Fast Typer",
    description:
      "I type at a high WPM, a skill that comes in handy for both coding and quick communication.",
  },
  {
    icon: <FaRocket className="text-2xl text-mint-500 dark:text-riptide-400" />,
    title: "Full-Stack Aficionado",
    description:
      "I enjoy the entire process of bringing an idea to life, from the initial design to the final deployment.",
  },
  {
    icon: <FaGlobe className="text-2xl text-mint-500 dark:text-riptide-400" />,
    title: "Web Enthusiast",
    description:
      "I'm fascinated by the digital landscape and love building products that make a real impact on users.",
  },
  {
    icon: <SiN8N className="text-2xl text-mint-500 dark:text-riptide-400" />,
    title: "Certified n8n Automation Develope",
    description:
      "Completed n8n Level 1 & 2 certifications. I design automated workflows to optimize processes and enhance efficiency.",
  },
];
const FunFactsSection = () => {
  return (
    <section className="">
      <div>
        <h2 className="text-xl font-bold text-mint-700 dark:text-riptide-300 text-left">
          Fun Facts
        </h2>
        <div className="h-1 w-10 bg-mint-500 dark:bg-riptide-400 rounded-full mt-2 mb-6 "></div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
        {funFacts.map((fact, index) => (
          <div
            key={index}
            className="p-5 rounded-xl bg-white/90 dark:bg-mint-900 backdrop-blur-md hover:shadow-lg hover:shadow-mint-200 dark:hover:shadow-mint-700 transition-all hover:scale-105"
          >
            <div className="flex items-center gap-4">
              <div>{fact.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-blacktext dark:text-white">
                  {fact.title}
                </h3>
                <p className="text-sm text-mint-800 dark:text-mint-200 mt-1">
                  {fact.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FunFactsSection;
